module.exports = __webpack_public_path__ + "img/substance.cb4e44e5.gif";